import { Alert } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { AppraisalEvaluationTab } from '~/scenes/PerformanceModule/components/Tabs/AppraisalEvaluationTab';
import { FeedbackTab } from '~/scenes/PerformanceModule/components/Tabs/Feedback';
import { GoalEvaluationTab } from '~/scenes/PerformanceModule/components/Tabs/GoalEvaluationTab';
import { GoalSettingTab } from '~/scenes/PerformanceModule/components/Tabs/GoalSettingTab';
import { NotesTab } from '~/scenes/PerformanceModule/components/Tabs/NotesTab';
import { PerformanceEvaluationTab } from '~/scenes/PerformanceModule/components/Tabs/PerformanceEvaluationTab';
import { SelfEvaluationTab } from '~/scenes/PerformanceModule/components/Tabs/SelfEvaluationTab';
import { StatusDiscussionTab } from '~/scenes/PerformanceModule/components/Tabs/StatusDiscussionTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { EmployeeModuleTabs } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/components/EmployeeModuleTabs';
import { EmployeeModuleTabPath_Performance } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/PerformanceModule/data';
import { useEmployeePerformanceModule } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/PerformanceModule/useEmployeePerformanceModule';

type PropsType = {
  hasFullAccess: boolean;
  modulePath: string;
};

export const EmployeePerformanceModule = (props: PropsType) => {
  const { hasFullAccess, modulePath } = props;

  const { isLoading, tabs, enabledTabPaths, defaultTab } =
    useEmployeePerformanceModule({
      hasFullAccess,
      modulePath,
    });

  const { t } = useTranslation();

  const renderTabContent = (tab: string) => {
    if (!enabledTabPaths.map((p) => p.toString()).includes(tab)) {
      return <Alert severity={'error'}>{t('laNoAuthorization')}</Alert>;
    }

    switch (tab) {
      case EmployeeModuleTabPath_Performance.GoalSetting:
        return <GoalSettingTab />;
      case EmployeeModuleTabPath_Performance.GoalEvaluation:
        return <GoalEvaluationTab />;
      case EmployeeModuleTabPath_Performance.SelfEvaluation:
        return <SelfEvaluationTab />;
      case EmployeeModuleTabPath_Performance.Feedback:
        return <FeedbackTab />;
      case EmployeeModuleTabPath_Performance.PerformanceEvaluation:
        return <PerformanceEvaluationTab />;
      case EmployeeModuleTabPath_Performance.Notes:
        return <NotesTab />;
      case EmployeeModuleTabPath_Performance.StatusDiscussion:
        return <StatusDiscussionTab />;
      case EmployeeModuleTabPath_Performance.AppraisalEvaluation:
        return <AppraisalEvaluationTab />;
      default:
        return <></>;
    }
  };

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <EmployeeModuleTabs
      defaultTab={defaultTab}
      enabledTabPaths={enabledTabPaths}
      tabs={tabs}
      render={(tab) => (
        <PortalErrorBoundary>{renderTabContent(tab)}</PortalErrorBoundary>
      )}
    />
  );
};
